import { usePermission, useAnyPermission } from '../hooks/usePermission';

/**
 * Render children only if the user has the required permission.
 *
 * Props:
 *   permission  — single permission key (string)
 *   any         — array of permission keys; passes if user has ANY of them
 *   fallback    — optional element to render when denied
 */
export function PermissionGate({ permission, any: anyPerms, children, fallback = null }) {
  const singleAllowed = usePermission(permission ?? '__noop__');
  const anyAllowed = useAnyPermission(...(anyPerms ?? []));

  const allowed = permission ? singleAllowed : anyPerms ? anyAllowed : true;

  return allowed ? children : fallback;
}
